import React, { useState } from 'react';
import {
  Container,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Button,
  TextField,
  Box,
} from '@mui/material';
import { useQuery } from '@apollo/client';
import ProductRow from './ProductRow';
import { SHOPIFY_INVENTORY_ITEMS } from '../../../graphql/queries';
import CreateListingModal from '../../../Components/Modals/CreateListingsModal/CreateListingsModal';
import { ShopifyInventoryItem } from '../../../graphql/generated';

const MyInventory: React.FC = () => {
  const { loading, error, data } = useQuery(SHOPIFY_INVENTORY_ITEMS);
  const [expanded, setExpanded] = useState<{ [key: string]: boolean }>({});
  const [selected, setSelected] = useState<{ [key: string]: boolean }>({});
  const [modalOpen, setModalOpen] = useState(false);

  if (loading) return <CircularProgress data-testid="loading-spinner" />;
  if (error) return <p data-testid="error-message">Error: {error.message}</p>;

  const handleExpandClick = (productId: string) => {
    setExpanded(prevExpanded => ({
      ...prevExpanded,
      [productId]: !prevExpanded[productId]
    }));
  };

  const handleSelectProduct = (productId: string) => {
    const isSelected = !selected[productId];
    setSelected(prevSelected => ({
      ...prevSelected,
      [productId]: isSelected
    }));
  };

  const handleModalOpen = () => {
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };

  const selectedProducts = data.shopifyInventoryItems.filter((product: ShopifyInventoryItem) => selected[product.id]);

  return (
    <Container maxWidth="lg">
      <Typography variant="h4" gutterBottom>
        My Inventory
      </Typography>
      <Box display="flex" justifyContent="space-between" mb={2}>
        <TextField label="Search" variant="outlined" />
        <Box>
          <Button variant="outlined" style={{ marginRight: 10 }}>Sync Inventory</Button>
          <Button variant="outlined" style={{ marginRight: 10 }}>Manual Entry</Button>
          <Button variant="contained" onClick={handleModalOpen}>Create Listing</Button>
        </Box>
      </Box>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell></TableCell>
              <TableCell>Image</TableCell>
              <TableCell>Product Title</TableCell>
              <TableCell>SKU</TableCell>
              <TableCell>Price</TableCell>
              <TableCell>Quantity</TableCell>
              <TableCell>Inventory Item ID</TableCell>
              <TableCell>Product ID</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.shopifyInventoryItems.map((product: ShopifyInventoryItem) => (
              <ProductRow
                key={product.id}
                product={product}
                expanded={expanded}
                handleExpandClick={handleExpandClick}
                handleSelectProduct={handleSelectProduct}
                selected={selected}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <CreateListingModal open={modalOpen} onClose={handleModalClose} selectedProducts={selectedProducts} />
    </Container>
  );
};

export default MyInventory;
